// extracted by mini-css-extract-plugin
export default {"mapContainer":"LocationMiniMap_mapContainer__yWZOZ","map":"LocationMiniMap_map__YiqK6","zoomButtons":"LocationMiniMap_zoomButtons__YGPI9"};